import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useAutoCalculate } from './hooks';
import { TemporalDistributionFormItem } from './Fields';
import { SectionTitle } from '@/components/views/Report/KimLhc/Components/Shared/styles';
import { PartialResultBadge, ResultBadge, VideoDrawerHeader } from '@/components/views/Report/KimLhc/Components/Shared';
import { FieldNamesEnum } from '@/components/views/Report/KimLhc/types';

export function WorkOrganization(): JSX.Element {
	const WORK_ORGANIZATION_GROUP = FieldNamesEnum.WORK_ORGANIZATION;
	const { workOrganizationScore } = useAutoCalculate();

	return (
		<Col span={24}>
			<Row gutter={[0, 40]}>
				<Col span={24}>
					<VideoDrawerHeader title={I18n.get('Work Organization')} />
				</Col>
				<Col span={24}>
					<Row gutter={[0, 32]}>
						<Col span={24}>
							<Row align="middle" justify="space-between">
								<Col flex="1">
									<SectionTitle level={5}>
										{I18n.get('Work organization / temporal distribution')}
										<span style={{ color: '#d13342' }}>*</span>
									</SectionTitle>
								</Col>
								<Col>
									<ResultBadge value={workOrganizationScore} />
								</Col>
							</Row>
						</Col>
						<Col span={24}>
							<TemporalDistributionFormItem fieldName={[WORK_ORGANIZATION_GROUP, 'work_organization']} />
						</Col>
					</Row>
				</Col>
				<Col span={24}>
					<PartialResultBadge />
				</Col>
			</Row>
		</Col>
	);
}
